//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RichText from '~/components/common/RichText.vue'
import ArticleCategory from '~/components/franchising/ArticleCategory.vue'
import FranchiseNav from "~/components/franchising/FranchiseNav.vue"

export default {
  components: { ArticleCategory, RichText, FranchiseNav },
  layout: 'franchising',
  computed: {
    url() {
      if (process.browser) {
        return window.location.href
      }
    }
  },
  data() {
    return {
      ready: false,
    }
  },
  async asyncData({ $storyblok, params }) {
    const page = await $storyblok.getPage(`pages/franchising/blog/${params.slug}`)
    return {
      page: page.content
    }
  },
  head() {
    return this.$metadata(this.page)
  },
}
